<template>
	<div class="managWallet">
		<top-header></top-header>
		<b-container fluid >
		<b-row class="mb-3">	
			<top-nevleft></top-nevleft>
			
		 <b-col class="p-0">
		<!--<b-row class="breadcrumbrow mt-1 m-0">				
			<b-col>
			 <h5 class="text-center">Admin Dashboard</h5>
			</b-col>				
		 </b-row>-->
		<b-container fluid v-if="noAddwallet==0">
			<b-row class="mt-3 mb-2">
				<b-col class="col-md-6 col-sm-6 col-xs-6">
					<!-- <h3 class="text-left">Manage Seller</h3> -->
				</b-col>
				<b-col class="col-md-6 col-sm-6 col-xs-6 text-right">
				<download-csv type="button" class="btn mr-2 btn-dark btn-sm ml-3 mr-2 rounded-pill"  :data="recordsCsv" name="wallet_report.csv" size="sm ml-3 mr-2" ><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Export Report</download-csv>
				
					<b-button variant="dark" pill class="mr-2" size="sm ml-3 mr-2" @click="noAddwallet=1" v-if="selectedRow.length==0">Fund Transfer</b-button>
					
					<b-button v-if="selectedRow.length>0" variant="dark" pill size="sm ml-3 mr-2" @click="activateUsers">Fund Transfer</b-button>
					
					<!-- <b-link v-if="noAddaccount==0" @click="noAddaccount=1" variant="dark" pill class="mr-2" ><b-icon class="mr-2" icon="plus" aria-hidden="true"></b-icon>Fund Transfer</b-link> -->
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid v-if="noAddwallet==1" class="mt-3">
			<b-card>
				<b-row class="mt-3 mb-2">
					<b-col cols="3">
					</b-col>
					<b-col cols="4" class="">
						<h6>
							<!-- <div class="walletIcon"><b-icon class="ml-1 walletFont" icon="wallet2" aria-hidden="true"></b-icon></div> --> <div class="welletText"><span class="heading">Alluraa Wallet</span><br/><small>#ALLURA01</small></div></h6>
					</b-col>
					<b-col cols="3" class="">
						<h6>Wallet Balance <br/>
							<small>{{$root.currency()+$root.tofixed(blanceAdmin, 2)}}</small>  | <small><b-link href="/admin/wallet/transactionHistory" style="color:#931cde">History</b-link></small> </h6>
					</b-col> 
					<b-col cols="2" class="">
						<b-button variant="dark" pill class="mr-2" @click="addfundtoMyaccount">Add Fund</b-button>
					</b-col>
					
				</b-row>
				<hr/>
				<b-row class="mt-3 mb-2">
					<b-col class="bankAccountFotmLayout">
						<small>
						  <b-form-group  v-slot="{ ariaDescribedby }" class="mb-0">
						  <b-form-radio-group
							id="radio-slots"
							v-model="wallet.transaction"
							:options="optionsType"
							:aria-describedby="ariaDescribedby"
							name="radio-options-slots"				
							v-on:change="changeMessage"
						  >
						
						  </b-form-radio-group>
						</b-form-group>
					</small>
					</b-col>
					
				</b-row>
				<b-row class="mt-3 mb-2">
					<b-col >
					
						<form ref="form" @submit.stop.prevent="handleSubmitWallet">	
							<b-row>
							<b-col class="bankAccountFotmLayout">
								<b-form-group label-for="walletkey-input" label-size="sm" label-class="mb-2" class="mb-1" :state="walletState.wallet_key" invalid-feedback="Wallit ID is required!" label-cols-sm="3" content-cols-sm label="*Wallet Id" v-if="bulkTransfer==0">
								<b-form-input id="walletkey-input" :state="walletState.wallet_key" v-model="wallet.wallet_key"  @focusin="walletState.wallet_key = null" size="sm"></b-form-input>
								<span style="color: #b546dd;font-size:15px;">Wallet Balance: {{$root.currency()+$root.tofixed(paywalletBlance, 2)}}</span>
								</b-form-group>
								
								<b-form-group :state="walletState.transaction"  label-for="transaction-input" label-size="sm" label-class="mb-2" class="mb-1" invalid-feedback="Transaction is required!" label-cols-sm="3" content-cols-sm label="*Transaction Type">
										<b-form-select v-model="wallet.transaction" id="transaction-input" :state="walletState.transaction" v-on:change="walletState.transaction = null" size="sm">
										<b-form-select-option value="" hidden selected placeholder="select transaction">*Select Transaction</b-form-select-option>
										<b-form-select-option value="CR">Credit</b-form-select-option>
										<b-form-select-option value="DR">Debit</b-form-select-option>
										</b-form-select>
									</b-form-group>
									
									<b-form-group :state="walletState.reward_type"  label-for="reward_type-input" label-size="sm" label-class="mb-2" class="mb-1" invalid-feedback="Amount Type is required!" label-cols-sm="3" content-cols-sm label="*Reward Type">
										<b-form-select v-model="wallet.reward_type" id="reward_type-input" :state="walletState.reward_type" v-on:change="walletState.reward_type = null" size="sm">
										<b-form-select-option value="" hidden selected placeholder="select reward_type">*Select Reward Type</b-form-select-option>
										<b-form-select-option value="reward">Reward</b-form-select-option>
										<b-form-select-option value="cashback">Cashback</b-form-select-option>
										<b-form-select-option value="referral">Referral</b-form-select-option>
										<b-form-select-option value="none">None of Above</b-form-select-option>
										</b-form-select>
									</b-form-group>
								
								<b-form-group label-for="amout-input" label-size="sm" label-class="mb-2" class="mb-1" :state="walletState.amount" :invalid-feedback="walletError.amount" label-cols-sm="3" content-cols-sm label="*Amount" >
								<b-form-input id="amout-input" :state="walletState.amount" v-model="wallet.amount"  @focusin="walletState.amount = null" size="sm"></b-form-input>
								</b-form-group>
								
								<b-form-group label-for="desc-input" label-size="sm" label-class="mb-2" class="mb-1" :state="walletState.descriptions" invalid-feedback="Reason is required!" label-cols-sm="3" content-cols-sm label="*Reason" >
								<b-form-textarea v-model="wallet.descriptions"
									  rows="3"
									  placeholder="Type your reason here"
									id="desc-input" :state="walletState.descriptions"  @focusin="walletState.descriptions = null" ></b-form-textarea>
								</b-form-group>
							</b-col>
							</b-row>
							
							<b-row class="mt-2">
								<b-col class="text-right bankAccountFotmbtnLayout ">
									
									 <b-button type="reset" variant="light" @click="noAddwallet=0" class="btn-solid-cancel" pill>Cancel</b-button> <b-button pill type="submit" variant="dark" class="mr-2" style="width: 100px;">Transfer</b-button>
									 
								</b-col>
							</b-row>
							</form>

							
					</b-col>
					
				</b-row>
			</b-card>
			
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<!-- <b-row class="mt-4 px-3">
							<b-col lg="2" class="text-left">
								<span class="mr-2">Users Role</span> 
								<b-form-select v-model="filterbyRole" required size="sm" class="ml-5">
									<b-form-select-option value="null">All Role</b-form-select-option>
									<b-form-select-option v-for="uRor in usersRoles" :value="uRor.value"  :key="uRor.value" >{{uRor.text}}</b-form-select-option>
									
								</b-form-select>
								
								
							</b-col>
							
							<b-col lg="2" class="text-center">
								<b-button pill variant="primary"  @click="initload()" size="sm">Submit</b-button>
							</b-col>
							
							
							
							
							
							<b-col lg="4" offset-md="4" class="text-right">
							
								<download-csv type="button" class="btn btn-dark rounded-pill ml-2"  :data="recordsCsv" name="wallet_report.csv" size="sm" ><b-icon class="mr-2" icon="download" aria-hidden="true"></b-icon>Export Report</download-csv>
							
								
							</b-col>
						</b-row> -->
						<b-row class="mt-4 px-3">
							<b-col lg="7" class="text-left">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								
								<b-form-select v-model="filterbyRole" required size="sm" class="w-25 ml-2" v-on:change="initload()">
									<b-form-select-option value="null">All Role</b-form-select-option>
									<b-form-select-option v-for="uRor in usersRoles" :value="uRor.value"  :key="uRor.value" >{{uRor.text}}</b-form-select-option>
									
								</b-form-select>
								<b-button size="sm ml-3 mr-2" @click="selectAllRows">Select all</b-button>
								<b-button size="sm mr-2" @click="clearSelected">Clear selected</b-button>
							</b-col>
							
							<b-col lg="1" class="text-right">
							<!--<b-button v-if="selectedRow.length>0" size="sm ml-3 mr-2" @click="activateUsers">Fund Transfer</b-button> -->
							</b-col>
							
							
							
							
							<!-- <b-col lg="4" offset-md="1">-->
							<b-col lg="4" >
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
						
							
							
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" ref="selectableTable" selectable @row-selected="onRowSelected">
								<template v-slot:cell(selected)="{ rowSelected }">
											<template v-if="rowSelected">
										  <span aria-hidden="true">&check;</span>
										  <span class="sr-only">Selected</span>
										</template>
										<template v-else>
										  <span aria-hidden="true">&nbsp;</span>
										  <span class="sr-only">Not selected</span>
										</template>
									</template>
									<!-- <template v-slot:thead-top="">
										<b-tr>
											<b-th colspan="6"></b-th>
											<b-th variant="secondary" colspan="5" class="text-center">Monthly Information</b-th>
											<b-th colspan="2"></b-th>
										</b-tr>
									</template> -->
							<template v-slot:cell(userRole)="row">
								<span v-if="row.value==2">Seller</span>
								<span v-else-if="row.value==3">	Sales-advisor</span>
								<span v-else-if="row.value==4">Customer</span>
								<span v-else>Admin</span>
							</template>
							<template v-slot:cell(referer_id)="row">
								<span>{{row.value}}</span>
							</template>
							<template v-slot:cell(signup_count)="row">
								<span>{{row.value}}</span>
							</template>
							
							<template v-slot:cell(total_cr_amount)="row">
										<span v-if="row.value==null || row.value=='null'">{{$root.currency()+$root.tofixed(row.value,2)}}</span>
										<span v-else>{{$root.currency()+$root.tofixed(Number(row.value) - Number(row.item.total_dr_amount), 2)}}</span>
							</template>
									<template v-slot:cell(userStatus)="row">
										<b-badge pill variant="danger" v-if="row.value == 0">INACTIVE</b-badge>
										<b-badge pill variant="success" v-else>ACTIVE</b-badge>
									</template>
									<template v-slot:cell(rating)="row">
										<b-form-rating v-model="row.value" inline no-border readonly show-value show-value-max size="sm" variant="primary"></b-form-rating>
									</template>
									<template v-slot:cell(actions)="row">
										<!-- <b-button pill variant="primary" v-if="row.item.role!=1 && $root.chkperm('users','edit')" class="mr-1" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm">EDIT</b-button>-->
										<b-button pill variant="primary" class="mr-1" @click="wallet.wallet_key=row.item.wallet_key,noAddwallet=1,paywalletBlance=Number(row.item.total_cr_amount) - Number(row.item.total_dr_amount),bulkTransfer=0" size="sm">Pay</b-button>
										<b-button pill variant="primary" v-if="row.item.role!=1 && $root.chkperm('users','edit')" class="mr-1" @click="showViewModal(row.item, row.index, $event.target)" size="sm">History</b-button>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6" class="text-left">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>

			
			
				<b-modal id="viewProfile" title="Wallet History" size="lg">
					
					<b-card >
					<b-row class="mb-3 mt-3">
						
						<b-col>
							<h6><div class="walletIcon"><b-icon class="ml-1 walletFont" icon="wallet2" aria-hidden="true"></b-icon></div><div class="welletText"><span class="heading">Alluraa Wallet</span><br/><small>Your purse to shop on Alluraa</small></div></h6>
							
							<!-- <p>Hello {{$root.customer_info.custname}} (not {{$root.customer_info.custname}}? <b-link href="/customer/logout">Log out</b-link> )</p>
							<p>Fromt your account dashboard you can view your recent orders, manage your shipping and billing addresses and edit your password and account details.</p> -->
						</b-col>
						<b-col>
							<ul>
							<li>Wallet Balance</li>
							<li class="amountTextColor">{{$root.currency()+$root.tofixed(blance, 2)}}</li>
						</ul>
						</b-col>
					</b-row>
					
					<h6 class="ml-4">Transaction History</h6>
					<b-row class="mt-2 walletHistory">
						
						<b-col>
						<ul>
							<li v-if="transaction.length>0">
							<b-row class="walletAc"  v-for="transactionRor in transaction" :key="transactionRor.id">
								<b-col cols="2">
									<ul class="p-0">
										<li>Trxn.ID</li>
										<li>#{{transactionRor.id}}</li>
										<li><small>{{$moment(transactionRor.cr_date).format('DD-MM-YYYY')}}</small></li>
									</ul>
								</b-col>
								<b-col cols="8">{{transactionRor.cr_descriptions}}</b-col>
								<b-col cols="2">
								<span v-if="loginUserId==transactionRor.cr_user_id">
								+{{$root.currency()+ $root.tofixed(transactionRor.cr_amount, 2)}} 
								</span>
								<span v-else>
								-{{$root.currency()+ $root.tofixed(transactionRor.dr_amount, 2)}} 
								</span>
								</b-col>
								
								</b-row>
								</li>
								<li v-else>
									No transaction found!
								</li>
							
						</ul>
							
						</b-col>
					</b-row>
					</b-card>

							
						
			<template v-slot:modal-footer="{ ok, close }">
				<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
				
				<!-- <b-button size="sm ml-3 mr-2" variant="success" @click="sendBulkemail(1)">Update Profile Email</b-button> -->
				
			</template>
		</b-modal>
	
		<b-modal id="viewAddfundtoMyaccount" title="Add Fund" size="sm" hide-footer>
							<b-row class="mb-1">
								<b-col lg="12" md="12" sm="12">
						<form ref="form" @submit.stop.prevent="walletAddFund">	
								<b-row>
								<b-col class="bankAccountFotmLayout">
									
									
									
									
									<b-form-group label-for="amoutadd-input" label-size="sm" label-class="mb-2" class="mb-1" :state="walletaddState.amount" :invalid-feedback="walletaddError.amount" label-cols-sm="3" content-cols-sm label="*Amount" >
									<b-form-input id="amoutadd-input" :state="walletaddState.amount" v-model="walletadd.amount"  @focusin="walletaddState.amount = null" size="sm"></b-form-input>
									</b-form-group>
									
									
								</b-col>
								</b-row>
								
								<b-row class="mt-2">
									<b-col class="text-right  ">
										
										 <b-button pill type="submit" variant="dark" class="mr-2" >Add Fund</b-button>
										 
									</b-col>
								</b-row>
								</form>

								</b-col>
							</b-row>
				</b-modal>
				<b-modal id="viewWalletdetails" title="Wallet Details" size="sm" hide-footer>
					<b-row class="mb-1">
						<b-col lg="12" md="12" sm="12">
							<b-table-simple hover small caption-top responsive>
								<!--<caption></caption>-->
								<!--<b-thead head-variant="light">
									<b-tr>
										<b-th colspan="2">Account Details</b-th>
									</b-tr>
								</b-thead>-->
								<b-tbody>
									<b-tr>
										<b-th>Beneficiary Name</b-th>
										<b-th class="text-right">{{bankwalletDetails.beneficiary}}</b-th>
									</b-tr>
									<b-tr>
										<b-th>Phone Number</b-th>
										<b-th class="text-right">{{bankwalletDetails.phone}}</b-th>
									</b-tr>
									<b-tr>
										<b-th>Wallet Name</b-th>
										<b-th class="text-right">{{bankwalletDetails.wallet_name}}</b-th>
									</b-tr>
									<b-tr>
										<b-th>Status</b-th>
										<b-th class="text-right">
										<b-badge pill variant="danger" v-if="bankwalletDetails.status == 0">INACTIVE</b-badge>
										<b-badge pill variant="success" v-else>ACTIVE</b-badge>
										
										
										</b-th>
									</b-tr>
									
							   </b-tbody>
							</b-table-simple>
						</b-col>
					</b-row>
			</b-modal>

			
			
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
		<top-footer></top-footer>
	</b-col>
	</b-row>
		
	</b-container>
	</div>
	
</template>
<script>
//import Header from "@/components/admin/Header.vue";
import Header from "@/components/header.vue";
import Footer from "@/components/footer-admin.vue";
import TreeviewPage from "@/components/admin/nevleft.vue";
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"top-footer": Footer,
		"top-nevleft": TreeviewPage,
	},
	mounted(){
		var self = this;
		Object.assign(self.selectedItem, self.emptyItem);
		this.initload();
	},
	data() {
		//var self = this;
		return{
			loading: true, 
			breadcrumb: [
				{
					text: 'Home',
					href: '/'
				},
				{
					text: 'Users',
					active: true
				}
			],
			recordUrl: this.$root.WEBAPI+'walletapi/walletadmin-record',
			urlTransferWallet: this.$root.WEBAPI+'walletapi/fundtransfer',
			urlTransferWalletbulk: this.$root.WEBAPI+'walletapi/fundtransferBulk',
			updateUrl: this.$root.WEBAPI+'secureapi/customers-update',
			deleteUrl: this.$root.WEBAPI+'secureapi/customers-delete',
			//recordBankUrl: this.$root.WEBAPI+'secureapi/customers-bannk',
			sendEmailbulkUrl: this.$root.WEBAPI+'secureapi/sendEmailbulk',
			transactionHisUrl: this.$root.WEBAPI+'walletapi/mywalletTransaction-record',
			recordadmiWalletUrl: this.$root.WEBAPI+'walletapi/mywallet-record',
			urlTransferAdminWallet: this.$root.WEBAPI+'walletapi/fundtransferAdmin',
			records: [],
			accountDetails: [],
			businessDetails: [],
			bankDetails: [],
			walletDetails: [],
			orderDetails: [],
			orderCancelled: [],
			orderFulfillment: [],
			orderRefunded: [],
			agentShare: [],
			loginCount:{totalLoginTime:''},
			loginTime:{lastLoginTime:''},
			bankAccountDetails:[],
			bankwalletDetails:[],
			selected: [],
			statusOptions: [{ value: 0, text: 'Disabled' },{ value: 1, text: 'Enabled' }],
			user_roles: [],
			fields: [
				{ key: 'Selected',label: 'Selected'},
				{ key: 'wallet_key', label: 'Wallet ID'},
				/* { key: 'uniq_id', label: 'Unique ID'}, */
				{ key: 'username', label: 'Username'},
				/* { key: 'rating', label: 'Rating'}, */
				{ key: 'email', label: 'Email'},
				{ key: 'userRole', label: 'Role'},
				{ key: 'referer_id', label: 'Coupon code'},
				{ key: 'signup_count', label: 'Sign up'},
				/*{ key: 'secure_code', label: 'Secure Code' },
				{ key: 'total_earning', label: 'Earning', class:'text-right' },
				{ key: 'total_customers', label: 'Customers', class:'text-right' },*/
				{ key: 'total_cr_amount', label: 'Wallet Balance',sortable: true, class:'text-center' },
				{ key: 'userStatus', label: 'User Status', class:'text-center' },
				{ key: 'actions', label: 'Actions', 'extra': 1, class:'text-right' }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100,200,300,500],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			filterbyRole:null,
			selectedItem: {},
			emptyItem: {
				id: 0,
				username: '',
				email: '',
				role: 0,
				secure_code: '',
				password: '',
				status: 0
			},
			
			selectedOP: 'whatsapp',
			optionsType: [ 
			  { text: 'Credit to account', value: 'CR' },
			  { text: 'Debit From Account', value: 'DR' },
			 // { text: 'Message 3', value: 'tweeter' },
			  //{ text: 'Message 4', value: 'telegram' },
			 // { text: 'Message 5', value: 'instagram' }
			],
			wallet:{
				wallet_key:'',
				transaction:'',
				amount:'',
				descriptions:'',
				reward_type:''
				},
			walletState:{
				wallet_key:null,
				transaction:null,
				amount:null,
				descriptions:null,
				reward_type:null,
			},	
			walletError:{
				wallet_key:null,
				transaction:null,
				amount:'Amount is required!',
				descriptions:null,
				reward_type:null,
			},
			walletadd:{
				amount:'',
				
				},
			walletaddState:{
				
				amount:null,
				
			},	
			walletaddError:{
				amount:'Amount is required!',
			},
			usersRoles:[],
			noAddwallet:0,
			walletRecord: [],
			transaction: [],
			blance: 0,
			cr_amount: 0,
			dr_amount: 0,
			loginUserId:0,
			blanceAdmin:0,
			paywalletBlance:0,
			selectedRow:[],
			bulkTransfer:0,
			recordsCsv: [],
			
		};
	},
	methods: {		
		showAddModal(){
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.$root.$emit('bv::show::modal', 'my-modal');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			this.selectedItem.password = '';
			this.$root.$emit('bv::show::modal', 'my-modal', button)
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete User.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						delete_id: item.uniq_id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}

			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('my-modal');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key'),
				role:self.filterbyRole,

			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//var filteredarr = self.filtercategory(response.data.result);
					var recordData   = response.data.result.records;
					//self.records = response.data.result.records;
					//self.records.options = JSON.parse(self.records.options);
					self.usersRoles = response.data.result.usersRoles;
					self.loading = false;
					//self.totalRows = self.records.length;
					
					
					/* Add Filter */
					//console.log('MyF'+self.filterbyRole);
					if(self.filterbyRole==null || self.filterbyRole=='null'){
						self.records=[];
						self.recordsCsv=[];
						//console.log('meNOfil');
						self.records = response.data.result.records;
						self.totalRows = self.records.length;
						//self.recordsCsv.push(self.records);
						recordData.forEach(item => {
								var usRoleName='Admin';
								if(item.userRole==2){
									usRoleName='Seller';
								}else if(item.userRole==3){
									usRoleName='Sales-advisor';
								}else if(item.userRole==4){
									usRoleName='Customer';
								}else{
									usRoleName='Admin';
								}
								
								var balance=0;
								if(item.total_cr_amount==null || item.total_cr_amount=='null'){								
									balance =item.total_cr_amount>0?item.total_cr_amount:0;
								}else{									
									balance =Number(item.total_cr_amount) - Number(item.total_dr_amount);
								}
								
								var arrayCsv={'Wallet ID':item.wallet_key,'Username':item.username,'Email':item.email,'Role':usRoleName,'Balance (Rs.)':balance,};					
								self.recordsCsv.push(arrayCsv);
								

						});
					}else{
						
						self.records=[];
						self.recordsCsv=[];
						recordData.forEach(item => {
						
							if(self.filterbyRole==item.userRole){
								//console.log('MyF2:'+self.filterbyRole+'|role:'+item.userRole);
								
								
								var usRoleName='Admin';
								if(item.userRole==2){
									usRoleName='Seller';
								}else if(item.userRole==3){
									usRoleName='Sales-advisor';
								}else if(item.userRole==4){
									usRoleName='Customer';
								}else{
									usRoleName='Admin';
								}
								
								var balance=0;
								if(item.total_cr_amount==null || item.total_cr_amount=='null'){								
									balance =item.total_cr_amount>0?item.total_cr_amount:0;
								}else{									
									balance =Number(item.total_cr_amount) - Number(item.total_dr_amount);
								}
								
								var arrayCsv={'Wallet ID':item.wallet_key,'Username':item.username,'Email':item.email,'Role':usRoleName,'Balance (Rs.)':balance,};					
								self.recordsCsv.push(arrayCsv);
								self.records.push(item);
							}

						});
						self.totalRows = self.records.length;
					}
					
				}
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
			/*MyWallet lance */
			self.axios.post(self.recordadmiWalletUrl, {
				accesskey: self.$session.get('access_key'),
				roleId: self.$root.customer_info.role,
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					//self.walletRecord = response.data.result;
					self.blanceAdmin		=	response.data.result.blance;
					//self.cr_amount	=	response.data.result.cr_amount;
					//self.dr_amount	=	response.data.result.dr_amount;
					//console.log(self.share_data);
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		showViewModal(item, index, button) {
				var self = this;
				self.accountDetails= item;
				self.businessDetails= item;
				//console.log('userId:'+item.id);
				
				
				var emailData = {fullname:item.username,email:item.email};
				self.selected.push(emailData);
				
				self.walletRecord = [];
				self.blance		=	0;
				self.cr_amount	=	0;
				self.dr_amount	=	0;
				self.transaction	=	[];
				self.loginUserId	=item.user_id;
				
				
				/* --------------- bankDetails ------------- */
				var userId=item.user_id;
				self.axios.post(self.transactionHisUrl, {
					accesskey: self.$session.get('access_key'),
					user_id:userId,
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						self.walletRecord = response.data.result;
						self.blance		=	response.data.result.blance;
						self.cr_amount	=	response.data.result.cr_amount;
						self.dr_amount	=	response.data.result.dr_amount;
						self.transaction	=	response.data.result.transaction;
					}
				})
				.catch(function (error) {
					alert(error);
				});
				
				/* -------------------- */
				
				
				
				
				
				
				self.selectedItem = Object.assign({}, item);
				self.selectedItem.password = '';
				self.$root.$emit('bv::show::modal', 'viewProfile', button)
			},
							
			showMywallet(walletItem,button){
				var self = this;
				self.bankwalletDetails= walletItem;
				self.$root.$emit('bv::show::modal', 'viewWalletdetails', button);
			},
			addfundtoMyaccount(){
				var self = this;
				//self.bankAccountDetails= accountItem;
				//console.log(accountItem);
				self.$root.$emit('bv::show::modal', 'viewAddfundtoMyaccount');
			},
			changeMessage(arg){
			console.log(arg);
            //console.log('CHANGE MESSAGE '+social_options[$root.share.social]);
           // this.linkComments = this.social_options[arg];
			
			},
			checkFormValidityWallet() {
				var valid = true;
				if(this.bulkTransfer==0){
					if(this.wallet.wallet_key.length < 3){
						valid = false;
						this.walletState.wallet_key = false;
					}else{
						this.walletState.wallet_key= true;
					}
				}
				
				if(this.wallet.transaction.length < 1){
					valid = false;
					this.walletState.transaction = false;
				}else{
					this.walletState.transaction= true;
				}
				
				if(this.wallet.reward_type.length < 1){
					valid = false;
					this.walletState.reward_type = false;
				}else{
					this.walletState.reward_type= true;
				}
				
				if(this.wallet.amount.length <1){
					this.walletError.phone='Please enter amount!';
					valid = false;
					this.walletState.amount = false;
				}else if(!/^[0-9]+$/.test(this.wallet.amount)){
					this.walletError.amount='Amout should be only digits!';
					valid = false;
					this.walletState.amount = false;
				
				}else if(Number(this.wallet.amount)<0){
					this.walletError.phone='Please enter amount!';
					valid = false;
					this.walletState.amount = false;
				}else{
				this.walletState.amount= true;
				}
				
				
				if(this.wallet.descriptions==''){
					valid = false;
					this.walletState.descriptions = false;
				}else{
					this.walletState.descriptions= true;
				}
				
				/* if(this.wallet.status==''){
				valid = false;
				this.walletState.status = false;
				}else{
				this.walletState.status= true;
				} */
			
			return valid;
			},
			handleSubmitWallet(){
						if (!this.checkFormValidityWallet()) {
						return;
						}
						var self = this;
						
						var urlPost =self.urlTransferWallet;
						if(self.bulkTransfer==1){
							urlPost =self.urlTransferWalletbulk;
						}
						
						self.axios.post(urlPost, {
							accesskey: self.$session.get('access_key'),
							wallet_key: self.wallet.wallet_key,
							bulkWallet: self.selectedRow,
							data: self.wallet,
						}).then(function (response) {
							if(response.data.error == 0 || response.data.error == '0'){
								self.$bvToast.toast(response.data.message, {
										title: 'Transfer Status',
										toaster: 'b-toaster-bottom-right',
										autoHideDelay: 5000,
										variant: 'success',
										solid: true,
										appendToast: true
								});
								
								self.wallet={
									wallet_key:'',
									transaction:'',
									amount:'',
									descriptions:'',
									};
								self.walletState = {
									wallet_key:null,
									transaction:null,
									amount:null,
									descriptions:null,
								};
								self.noAddwallet=0;
								//self.bulkTransferBtn=0;
								self.initload();
								//self.inLodcard();
								//self.initProfile();
							}else{
								self.error_msg = response.data.message;
								self.$bvToast.toast(response.data.message, {
								title: 'Wallet',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'danger',
								solid: true,
								appendToast: true
								});
							
							}

						}).catch(function (error) {
								alert(error);
						});
					
					

				},
				checkFormValidityAddWallet() {
					var valid = true;
					
					
					if(this.walletadd.amount.length <1){
						this.walletaddError.phone='Please enter amount!';
						valid = false;
						this.walletaddState.amount = false;
					}else if(!/^[0-9]+$/.test(this.walletadd.amount)){
						this.walletaddError.amount='Amout should be only digits!';
						valid = false;
						this.walletaddState.amount = false;
					
					}else if(Number(this.walletadd.amount)<0){
						this.walletError.phone='Please enter amount!';
						valid = false;
						this.walletaddState.amount = false;
					}else{
					this.walletaddState.amount= true;
					}
					
					
					
					/* if(this.wallet.status==''){
					valid = false;
					this.walletState.status = false;
					}else{
					this.walletState.status= true;
					} */
				
				return valid;
				},
				walletAddFund(){
						if (!this.checkFormValidityAddWallet()) {
						return;
						}
						var self = this;
						self.axios.post(self.urlTransferAdminWallet, {
							accesskey: self.$session.get('access_key'),
							wallet_key: self.wallet.wallet_key,
							amount:self.walletadd.amount,
						}).then(function (response) {
							if(response.data.error == 0 || response.data.error == '0'){
								self.$bvToast.toast(response.data.message, {
										title: 'Transfer Status',
										toaster: 'b-toaster-bottom-right',
										autoHideDelay: 5000,
										variant: 'success',
										solid: true,
										appendToast: true
								});
								
								self.walletadd={
									amount:'',
									};
								self.walletaddState = {
									wallet_key:null,
									transaction:null,
									amount:null,
									descriptions:null,
								};
							
								self.$bvModal.hide('viewAddfundtoMyaccount');
								self.initload();
								//self.initProfile();
							}else{
								self.error_msg = response.data.message;
								self.$bvToast.toast(response.data.message, {
								title: 'Wallet',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'danger',
								solid: true,
								appendToast: true
								});
							
							}

						}).catch(function (error) {
								alert(error);
						});
					
					

				},
			onRowSelected(items) {
			console.log(items);
			this.selectedRow = items;
			
		  },
		selectAllRows() {
			this.$refs.selectableTable.selectAllRows()
		  },
		  clearSelected() {
			this.$refs.selectableTable.clearSelected();
			
		  },
		  	activateUsers(){
					var self = this;
					if(self.selectedRow.length>0){
					
					
					this.$bvModal.msgBoxConfirm('Please confirm that you want to Bulk Fund Transfer!.', {
						title: 'Please Confirm',
						size: 'sm',
						buttonSize: 'sm',
						okVariant: 'danger',
						okTitle: 'YES',
						cancelTitle: 'NO',
						footerClass: 'p-2',
						hideHeaderClose: false,
						centered: true
					})
					.then(value => {
						if(value == true){
								self.noAddwallet=1;
								self.bulkTransfer=1;
								 self.wallet.wallet_key='';
							
						}else{
							//alert('no '+item.id);
						}
					})
					.catch(err => {
						// An error occurred
						console.log(err);
					})
				}else{
					self.$bvToast.toast('Please Select Row!', {
										title: 'Bulk Transfer',
										toaster: 'b-toaster-bottom-right',
										autoHideDelay: 5000,
										variant: 'warning',
										solid: true,
										appendToast: true
									});
				
				}
			}




	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
.managWallet{
	.bankAccountFotmLayout {
		padding: 0 24%;
	}
	.bankAccountFotmbtnLayout {
		padding: 0 23%;
	}
	
	
	
}
.walletIcon{
		float:left;
		
		.walletFont{
			font-size:50px;
			color:#a437e9;
		}
	}
	.welletText{
			width: 98%;
		.heading{ font-size:23px;}
	}
	.amountTextColor{ color:#a437e9; } 
	
	.walletHistory{
	width: 90%;
    font-size: 14px;
		
		.walletAc{border-top: 1px solid #c6c6c6;
		padding-top: 7px;
		border-bottom: 1px solid #c6c6c6;
		padding-bottom: 7px;}
		
		.walletAp{
		padding-top: 7px;
		border-bottom: 1px solid #c6c6c6;
		padding-bottom: 7px;}
		
		.hlink{
		margin-left:10px;
		color:#a437e9;
		}
	}
</style>

